import React from "react";

function RetryIcon({ className }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.0312 3.96875C10.0125 2.95 8.56875 2.3625 6.98125 2.525C4.6875 2.75625 2.8 4.61875 2.54375 6.9125C2.2 9.94375 4.54375 12.5 7.5 12.5C9.49375 12.5 11.2062 11.3313 12.0062 9.65C12.2062 9.23125 11.9062 8.75 11.4437 8.75C11.2125 8.75 10.9937 8.875 10.8938 9.08125C10.1875 10.6 8.49375 11.5625 6.64375 11.15C5.25625 10.8438 4.1375 9.7125 3.84375 8.325C3.31875 5.9 5.1625 3.75 7.5 3.75C8.5375 3.75 9.4625 4.18125 10.1375 4.8625L9.19375 5.80625C8.8 6.2 9.075 6.875 9.63125 6.875H11.875C12.2188 6.875 12.5 6.59375 12.5 6.25V4.00625C12.5 3.45 11.825 3.16875 11.4313 3.5625L11.0312 3.96875Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default RetryIcon;
